import {ReactNode} from 'react';

import {Box, SxProps, Theme, Typography} from '@mui/material';

import {EmpionPaper} from '../../../../components/EmpionPaper/EmpionPaper';
import {empionGreen, empionOrange} from '../../../../layouts/theme/EmpionColors';

interface Props {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  dataTour?: string;
  sx?: SxProps<Theme>;
}

export const ProfileSection = ({title, children, actions, dataTour, sx}: Props) => {
  return (
    <Box data-tour={dataTour} sx={{mb: 3}}>
      <EmpionPaper
        elevation={0}
        sx={{
          border: `1px solid ${empionOrange[3]}`,
          borderRadius: '16px',
          backgroundColor: 'white',
          overflow: 'hidden',
          px: {xs: 2, sm: 3},
          pt: 3,
          pb: 4,
          ...sx,
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 3}}>
          <Typography
            component='h2'
            sx={{fontSize: '20px', fontWeight: 700, lineHeight: 1.4, color: empionGreen[700]}}
          >
            {title}
          </Typography>
          {actions && <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>{actions}</Box>}
        </Box>
        {children}
      </EmpionPaper>
    </Box>
  );
};
